import LegalDocumentPage from './LegalDocumentPage';
import termsOfUsePdf from '@/assets/pdf/Ekan_TermodeUsoGeoescala_RSB_19062026.pdf';

export default function TermsOfUsePage() {
  return <LegalDocumentPage title="Termo de Uso" fileUrl={termsOfUsePdf} />;
}
